import types from './types';

const initialState = null;

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET:
      return action.location;

    default:
      return state;
  }
};

export default reducer;
